const ROOTS = {
  promoCodes: '/promo-codes',
  categories: '/categories',
  blog: '/blog',
  sout: '/sout',
};

export const paths = {
  root: '/',
  promoCodes: { root: ROOTS.promoCodes },
  categories: { root: ROOTS.categories },
  blog: { root: ROOTS.blog },
  sout: { root: ROOTS.sout },
} as const;

const API_ROOTS = {
  root: '/api',
  redirect: '/api/redirect',
};

export const apiPaths = {
  redirect: (domain: string) => `${API_ROOTS.redirect}/${domain}`,
};
//
